import { get } from 'lodash';
import routes from '../routes';
import { match } from 'react-router';

export const NoRouteMatchErrorText = 'current route did not match in getPageFromPathname while trying to log an event in the logging.js middleware';

export const allRoutes = [
    ...routes.map(page => ({
        path: page.path,
        pageName: page.pageName,
        category: page.category,
    })),
];

export function getPageFromPathname(pathname) {
    return new Promise((resolve, reject) => {
        match({
            location: pathname || window.location.pathname,
            routes: allRoutes,
        }, (error, redirectLocation, renderProps) => {
            if (renderProps) {
                const pageName = get(renderProps, 'routes[0].pageName', '');
                const category = get(renderProps, 'routes[0].category', '');
                resolve({
                    pageName,
                    category,
                });
            } else if (error) {
                reject(error);
            } else {
                reject(new Error(NoRouteMatchErrorText));
            }
        });
    });
}
